import React from 'react';
import { useParams } from 'react-router-dom';
import { urls } from '..';
import { getDBTimestampFromDate } from '../data/utils/getDBTimestampFromDate';
import { getPrematchAggs } from '../data/utils/getPrematchAggs';
import { getPrincipaleOPrimoGruppo } from '../data/utils/getPrincipaleOPrimoGruppo';
import { parseIntFromString } from '../data/utils/parseIntFromString';
import { useTimeline } from './/matches-by-date/TimelineProvider';
import { useIsMainSection } from '../common/IsMainSectionProvider';
import { getLabel } from '../data/labels';
import XRouterLink from '../common/seo/xrouter/XRouterLink';
import PrematchLinks from './PrematchLinks';
import { getConfiguration } from '../data/utils/configuration';

function AllButton() {
    const isMainSection = useIsMainSection();

    return (
        <>
            {isMainSection ?
                <XRouterLink to={`${urls.base}/${urls.prematch.base}`+(urls.prematch.home?`/${urls.prematch.home}`:'')} className="relative pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase">
                    <span className="my-auto text-xs text-cs4">{getLabel('prematch_page.temporal_filters.all')}</span>
                    <div className="absolute bottom-0 h-[4px] w-full self-center bg-cs4 rounded-t-lg"></div>
                </XRouterLink>
                :
                <XRouterLink to={`${urls.base}/${urls.prematch.base}`+(urls.prematch.home?`/${urls.prematch.home}`:'')} className="pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase">
                    <span className="my-auto text-xs text-cs3">{getLabel('prematch_page.temporal_filters.all')}</span>
                </XRouterLink>
            }
        </>
    );
}

const hoursButtons = [1, 3];
export const descFromHour = {
    1: getLabel('prematch_page.temporal_filters.1h', '1H'),
    3: getLabel('prematch_page.temporal_filters.3h', '3H'),
};

export default function DateSelectionNavbar(props) {
    const params = useParams();
    const timeline = useTimeline();

    if (timeline == null) {
        return null;
    }

    const today = getDBTimestampFromDate(new Date()).slice(0, 8);
    const hoursToday = timeline.weekDays[0];
    const conf = getConfiguration()

    return (
        <>
        {conf.bbc?.en &&
          <div className="prematchLinks__wrapper">
            <PrematchLinks />
          </div>}
        <div className="xs_dateSelectionNavbar w-full overflow-x-auto px-2 grid grid-flow-col auto-cols-auto bg-cs1 border-y border-y-cc7">
            <AllButton />
            {hoursButtons.map((b) => {
                const d = hoursToday;
                let [sportId, aggId] = [d.sport.id, d.sport.aggregata];
                if (params.sportId != null) {
                    if (params.aggId == null) {
                        const sportIdInt = parseIntFromString(params.sportId);
                        let aggs = getPrematchAggs(sportIdInt);
                        aggs = Array.from(Object.values(aggs));
                        const agg = getPrincipaleOPrimoGruppo(aggs);
                        sportId = params.sportId;
                        aggId = agg.idAggregata;
                    } else {
                        sportId = params.sportId;
                        aggId = params.aggId;
                    }
                }
                const dateAndHour = `${d.date}-${b}`;
                let dayUrl = props.openAllMatches
                    ? `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}/${dateAndHour}/${sportId}/${aggId}`
                    : `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${dateAndHour}/${sportId}/${aggId}`;
                // dayUrl = dayUrl + currentSearch;

                const isActive = params.date === dateAndHour
                return (
                    <XRouterLink
                        key={`${d.date}-${b}`}
                        to={dayUrl}
                        className={`pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase relative dateHour--${b} ${isActive ? 'active' : ''}`}
                    >
                        <span className={`my-auto text-xs !uppercase ${isActive ? 'text-cs4' : 'text-cs3'}`}>
                            +{descFromHour[b]}
                        </span>
                        {isActive && (
                            <div className="absolute bottom-0 h-[4px] w-full self-center bg-cs4 rounded-t-lg"></div>
                        )}
                    </XRouterLink>
                );
            })}
            {timeline.weekDays.map(d => {
                let [sportId, aggId] = [d.sport.id, d.sport.aggregata];
                if (params.sportId != null) {
                    // aggId not present in the URL, I try to find the main aggregate for the sportId
                    if (params.aggId == null) {
                        const sportIdInt = parseIntFromString(params.sportId);
                        let aggs = getPrematchAggs(sportIdInt);
                        aggs = Array.from(Object.values(aggs));
                        const agg = getPrincipaleOPrimoGruppo(aggs);
                        sportId = params.sportId;
                        aggId = agg.idAggregata;
                    } else {
                        sportId = params.sportId;
                        aggId = params.aggId;
                    }
                }
                let url = `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${d.date}/${sportId}/${aggId}`;
                if (props.openAllMatches) {
                    url = `${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${urls.prematch.allMatches}/${d.date}/${sportId}/${aggId}`;
                }
                return (
                    <React.Fragment key={d.id}>
                        {params.date === d.date ?
                            <XRouterLink to={url} replace={props.openAllMatches} key={d.id} className="relative pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase">
                                {d.date === today ?
                                    <span className="my-auto text-xs text-cs4">{getLabel('prematch_page.temporal_filters.today')}</span>
                                    :
                                    <>
                                        <span className="text-xs text-cs4">{d.desc}</span>
                                        <span className="text-xs text-cs4">{d.dateShort}</span>
                                    </>
                                }
                                <div className="absolute bottom-0 h-[4px] w-full self-center bg-cs4 rounded-t-lg"></div>
                            </XRouterLink>
                            :
                            <XRouterLink to={url} replace={props.openAllMatches} key={d.id} className="pb-[4px] min-w-[36px] inline-flex flex-col items-center font-bold uppercase">
                                {d.date === today ?
                                    <span className="my-auto text-xs text-cs3">{getLabel('prematch_page.temporal_filters.today')}</span>
                                    :
                                    <>
                                        <span className="text-xs text-cs3">{d.desc}</span>
                                        <span className="text-xs text-cs3">{d.dateShort}</span>
                                    </>
                                }
                            </XRouterLink>
                        }
                    </React.Fragment>
                );
            })}
        </div>
        </>
    );
}
